<template>
	<div>
		<a href="#" data-reveal-id="confirmModal" class="button alert expand tiny" @click="resetCounter">
			Reset
		</a>

		<div id="confirmModal" class="reveal-modal text-center small" data-reveal aria-labelledby="modalTitle" aria-hidden="true" role="dialog">


			<div class="row">
				<div class="columns">
					  <h3 id="modalTitle text-alert">Are you sure you want to reset all Setup Fees</h3>
					  <p class="lead">This will reset every member of your club to have no Setup Fee.</p>
					  <p>For clubs where setup-fees are mandatory contacts will need to add a new setup fee to their next order</p>
				</div>
			</div>

			<div class="row mtl">
				<div class="columns"><button  class="button alert expand" :disabled="disabled" @click="resetSetupFees">{{message}}</button></div>
			</div>
		  <a class="close-reveal-modal" aria-label="Close">&#215;</a>
		</div>
	</div>
</template>

<script>
'use strict';

	export default {
		name: 'ResetSetupFees',
		data() {
			return {
				loading: false,
				countDownTime: 10,
				counter: 10,
				timer: {}
			}
		},

		methods: {
			resetCounter() {
				this.counter = this.countDownTime;
				clearInterval(this.timer);
				this.countdown();
			},

			countdown() {			
				this.timer = setInterval(() => {
					if(this.counter > 0) {
						this.counter -= 1;
					} else {
						clearInterval(this.timer);
					}
				}, 1000);
			},
			async resetSetupFees() {
				this.loading = true;
				await this.$store.dispatch('RESET_SETUP_FEES');
				this.loading = false;
			}
		
		},

		computed: {
			secondsRemaining() {
				return this.counter;
			},

			disabled() {
				return this.counter != 0 || this.loading;
			},
			message() {
				if(this.loading) {
					return 'Please wait..'
				} else {
					return this.secondsRemaining > 0 ? `Please wait ${this.secondsRemaining} seconds` : 'Reset Setup Fees';
				}
			} 
		},
		beforeMount() {

		},

		mounted() {
			
		},
		created() {
			this.counter = this.countDownTime;
		}

	};
</script>


<style scoped>

[v-cloak] {
	display: none;
}

	
</style>